import { BankStatisticLine, StatisticStates } from "@/modules/bank/domain/BankStatisticLine";
import { BankStatisticRepository } from "@/modules/bank/domain/BankStatisticRepository";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export class ApiBankStatisticRepository implements BankStatisticRepository{

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor(){
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher
    }
    
    //BankStatisticLine company_id: number; company_name: string; deleted: boolean; states: StatisticStates
    //StatisticState: all: ; done: ;  draft: ;  errors: ;  deleted: ;  imported: ; deleted_done: ; pending_sync: ; pending_accounting: ;  

    api_to_domain(line){
        return new BankStatisticLine(line.id, line.name, line.del, new StatisticStates(line.states.all, line.states.done, line.states.draft, line.states.errors, line.states.deleted, line.states.imported, line.states.deleted_done, line.states.pending_sync, line.states.pending_accounting))        
    }
    
    async get_data(id: number|null):Promise<BankStatisticLine[]|null>{        
        let stat_data = await this.query_dispatcher.dispatch('get.bank.statistics', {contract_id:id})
        if(stat_data.results && stat_data.results.data){
            return stat_data.results.data.map(line => this.api_to_domain(line), this)
        }
        else {
            return []
        }        
    }
   
}